import { Suspense } from "react";
import { useRouteTransition } from "@/lib/route-transition";
import { Outlet, useRouterState } from "@organizacaox/lai-design-system/router";
import { Skeleton } from "@organizacaox/lai-design-system";
import { SettingsSkeleton } from "@/settings/settings-skeleton";
import { PageSkeleton } from "@/lib/page-states";
import { CoursePlayerSkeleton } from "@/courses/course-player-skeleton";
import { CourseCatalogSkeleton } from "@/courses/course-catalog-skeleton";
import { ShowcaseSkeleton } from "@/showcases/showcase-skeleton";

export function RouteLoadingScreen() {
  const { pathname, filter } = useRouterState({
    select: (state) => ({
      pathname: state.location.pathname,
      filter: state.location.search?.filter,
    }),
  });
  if (
    /^\/showcase(?:\/[^/]+)?\/?$/.test(pathname) ||
    /^\/admin\/branding\/vitrine\/[^/]+\/preview\/?$/.test(pathname)
  )
    return <ShowcaseSkeleton />;
  if (pathname === "/courses" || pathname === "/courses/library") {
    return (
      <CourseCatalogSkeleton
        includeToolbar
        layout={
          pathname === "/courses/library"
            ? "search"
            : filter && filter !== "all"
              ? "filtered"
              : "catalog"
        }
      />
    );
  }
  if (/^\/courses\/[^/]+\/lessons\/[^/]+\/?$/.test(pathname)) return <CoursePlayerSkeleton />;
  if (/^\/courses\/[^/]+\/?$/.test(pathname)) return <CoursePlayerSkeleton withPlaylist={false} />;
  if (pathname === "/settings" || pathname === "/settings/") return <SettingsSkeleton />;
  return (
    <div className="flex w-full min-w-0 flex-col gap-6">
      <Skeleton aria-hidden="true" className="h-9 w-64 max-w-full motion-reduce:animate-none" />
      <PageSkeleton label="Carregando página…" />
    </div>
  );
}

// A troca de página pode suspender sem esconder o menu ou o rodapé do app.
export function RouteContent() {
  const { pathname, navigating } = useRouterState({
    select: (state) => ({
      pathname: state.resolvedLocation?.pathname ?? state.location.pathname,
      navigating: state.isLoading && state.location.pathname !== state.resolvedLocation?.pathname,
    }),
  });
  const content = useRouteTransition(pathname, navigating);
  return (
    <>
      {navigating && <RouteLoadingScreen />}
      <div ref={content} hidden={navigating} data-route-content>
        <Suspense fallback={<RouteLoadingScreen />}>
          <Outlet />
        </Suspense>
      </div>
    </>
  );
}
